
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { categories } from '../../mocks/categories';

export default function Categories() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              تصفح الفئات
            </h1>
            <p className="text-lg max-w-2xl mx-auto text-gray-400">
              اختر الفئة المناسبة لك واستكشف مجموعة واسعة من المنتجات المتنوعة
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category) => (
              <Link 
                key={category.id}
                to={`/products?cat=${category.slug}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-300" style={{ backgroundColor: '#1B2D3E' }}>
                  <div className="aspect-[4/3] w-full h-full overflow-hidden">
                    <img 
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A]/90 via-[#0D1B2A]/40 to-transparent flex items-end">
                    <div className="p-8 w-full">
                      <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                        {category.name}
                      </h3>
                      <p className="mb-4" style={{ color: '#D4A84B' }}>{category.count} منتج متاح</p>
                      <div className="inline-flex items-center gap-2 font-semibold" style={{ color: '#D4A84B' }}>
                        <span>تصفح المنتجات</span>
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-arrow-left-line"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
